import React from 'react'
import { createRoot } from 'react-dom/client'
import { AppBar, AppContextProvider } from '@ampcore/design-system'

export default class AppBarElement extends HTMLElement {
  async connectedCallback() {
    this.mountPoint = document.createElement('div')

    const menuVersion = this.getAttribute('data-menu-items-version')
    const logoHref = this.getAttribute('data-logo-href')
    const searchUrl = this.getAttribute('data-search-url')
    const searchAutocompleteUrl = this.getAttribute(
      'data-search-autocomplete-url'
    )
    const menuItemsUrl = this.getAttribute('data-menu-items-url')
    const restrictToProspectDefaultAttr = this.getAttribute(
      'data-restrict-to-prospect-default'
    )
    const restrictToProspectDefault = restrictToProspectDefaultAttr === 'true'

    // Check for data-use-shadow-root attribute (default false)
    const useShadowRootAttr = this.getAttribute('data-use-shadow-root')
    const useShadowRoot = useShadowRootAttr === 'true'

    let mountContainer
    if (useShadowRoot) {
      const shadowRoot = this.attachShadow({ mode: 'open' })
      shadowRoot.appendChild(this.mountPoint)
      this.shadowRootAssets = this.querySelector('#shadow-root-assets')
      if (this.shadowRootAssets && this.shadowRootAssets.content) {
        shadowRoot.appendChild(this.shadowRootAssets.content)
      }
      mountContainer = this.mountPoint
    } else {
      this.appendChild(this.mountPoint)
      // Do not append shadow-root-assets outside shadow root
      mountContainer = this.mountPoint
    }

    const root = createRoot(mountContainer)

    // TODO avoid hard coding dynamic props
    root.render(
      <div className="u-adel-reset">
        <div className="u-block" style={{ display: 'none' }}>
          <AppContextProvider
            menuItemsUrl={menuItemsUrl}
            menuVersion={menuVersion}
            restrictToProspectDefault={restrictToProspectDefault}
          >
            <AppBar
              logoHref={logoHref}
              links={[
                {
                  variant: 'primary',
                  name: 'Find an Advisor',
                  url:
                    window.AMERIPRISE_ADVISORS_SITE_URL ||
                    `https://www.ameripriseadvisors.com/`,
                  className: 'u-sm-hidden u-md-hidden',
                  displayFor: { mode: 'show', statuses: ['prospect'] },
                  target: '_blank'
                },
                {
                  variant: 'secondary',
                  name: 'Return to My Accounts',
                  url: 'https://www.ameriprise.com/secure/overview',
                  analyticsName: 'return-to-my-accounts',
                  className: 'u-hidden u-lg-block',
                  displayFor: { mode: 'show', statuses: ['client_active'] }
                },
                {
                  variant: 'primary',
                  name: 'Log Out',
                  url: 'https://www.ameriprise.com/secure/logout',
                  displayFor: { mode: 'show', statuses: ['client_active'] }
                },
                {
                  variant: 'secondary',
                  name: 'Log In',
                  url: 'https://www.ameriprise.com/client-login',
                  displayFor: { mode: 'hide', statuses: ['client_active'] }
                }
              ]}
              searchPanel={{
                open: false,
                searchBox: {
                  label: 'Search Ameriprise.com',
                  searchUrl: searchUrl,
                  searchAutocompleteUrl: searchAutocompleteUrl
                }
              }}
              mobileBottomMenuItems={[
                {
                  name: 'Customer Service',
                  url: `https://www.ameriprise.com/customer-service`,
                  analyticsName: 'Customer Service'
                },
                {
                  name: 'Online security guarantee',
                  url: 'https://www.ameriprise.com/privacy-security-fraud/online-security-guarantee',
                  analyticsName: 'Online security guarantee'
                }
              ]}
            />
          </AppContextProvider>
        </div>
      </div>
    )
  }
}
